import React from 'react';

// Styles & Assets
import styles from './ChartSlider.module.css';
import { IoIosArrowBack } from 'react-icons/io';
import { IoIosArrowForward } from 'react-icons/io';

// Components
import Icon from '../../UI/Icon/Icon';

const ChartSlider: React.FC<{
    currentLabel: string
    disabled: boolean
    handleClickBack: () => void
    handleClickFordward: () => void
}> = ({ currentLabel, disabled, handleClickBack, handleClickFordward }) => {

    return (
        <div className={styles.backForwardContainer}>
            <button onClick={handleClickBack} disabled={disabled}>
                <Icon><IoIosArrowBack /></Icon>
            </button>
            <span>{currentLabel}</span>
            <button onClick={handleClickFordward} disabled={disabled}>
                <Icon><IoIosArrowForward /></Icon>
            </button>
        </div>
    );
};

export default ChartSlider;